<template>
  <div>
    <v-layout justify-center>
      <v-flex xs12 
        :sm8="mini" :md7="mini" :lg5="mini" :xl4="mini"
        :md11="!mini && !maxi" :lg10="!mini && !maxi" :xl8="!mini && !maxi"
      >
        <v-card>
          <v-container fluid>
            <o-big-title v-if="title">{{title}}</o-big-title>
            <o-description-title v-if="description">{{description}}</o-description-title>
            <o-main-progress v-if="loading" class="elevation-0" :texto="loadingText"/>
            <slot v-else></slot>
            <slot name="acciones">
              <v-layout wrap justify-center align-center>
                <slot name="aceptar">
                  <v-flex xs12>
                    <v-layout justify-center v-if="aceptar">
                      <v-btn
                        large
                        color="primary"
                        :disabled="disabled || saving || loading"
                        :loading="saving"
                        @click="$emit('aceptar')"
                      >
                        {{aceptar}}
                      </v-btn>
                    </v-layout>
                  </v-flex>
                </slot>
                <slot name="volver" v-if="!ocultarVolver">
                  <v-flex>
                    <o-btn-volver
                      @volver="$emit('volver')"
                      :disabled="saving || loading"
                    />
                  </v-flex>
                </slot>
              </v-layout>
            </slot>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>  
</template>

<script>
export default {
  name: 'popup-layout',
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    ocultarVolver: {
      type: Boolean,
      default: false
    },
    aceptar: {
      type: String,
      default: null
    },
    mini: {
      type: Boolean,
      default: false
    },
    maxi: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default () {
        return this.$t('general.misc.cargando')
      } 
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/PopUpLayout.vue